export const formatDate = (timestampNum: number) => {
    return (new Date(timestampNum)).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
}

export const formatTimestamp = (timestampNum: number) => {
    const date = new Date(timestampNum);
    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
    };
    return date.toLocaleTimeString('en-US', options);
}